/**
 * kumo.store のブラウザ依存の部分（テストで差し替える）と、決済の窓を開けなかったときのエラー。
 *
 * WHY store.ts から分けたか（2026-09-27 sdk-light）: 課金の本体（store.ts）は使うときだけ読む（/sdk/store-<hash>.mjs）。
 * ところが決済の窓（ポップアップ）は**クリックのハンドラの中で同期的に**開かないとブラウザに止められる。
 * 本体を読むのを待ってから開くと止められるので、遅延読み込みの窓口（lazyCommerce.ts）が本体より先にこの openWindow で窓を開き、
 * 読めたら本体に渡す。窓の開き方（名前・大きさ）とエラーの文面を 1 か所にするためにここへ置いた
 */

import { KumoError } from './core.js';

export interface StoreEnv {
  openWindow(): Window | null;
  currentUrl(): string;
  navigate(url: string): void;
  replaceUrl(url: string): void;
  sleep(ms: number): Promise<void>;
}

export function browserEnv(): StoreEnv {
  const g = globalThis as unknown as { window?: Window; location?: Location; history?: History };
  return {
    // 窓の名前もプレイヤーに Kumo を見せない（2026-09-27 kumo_checkout → checkout・master の変更を sdk-light の移動先へ）
    openWindow: () => g.window?.open('', 'checkout', 'popup=yes,width=480,height=760') ?? null,
    currentUrl: () => g.location?.href ?? '',
    navigate: (url) => g.location?.assign(url),
    replaceUrl: (url) => g.history?.replaceState(g.history.state, '', url),
    sleep: (ms) => new Promise((r) => setTimeout(r, ms))
  };
}

export const popupBlocked = () =>
  new KumoError(0, 'popup_blocked', 'The checkout window was blocked. Call store.purchase() from a click handler, or use { mode: "redirect" }.');
